export const heroFeature = {
  id: "lead-001",
  tag: "独家线索",
  title: "深夜片场临时换角风波：多方回应时间线一次看清",
  summary:
    "从流出的现场通告单到各方陆续发布的口径，黑料51瓜友把散落各处的碎片拼成了一条完整时间线，谁先谁后、哪句对得上，一眼就能看明白。",
  heat: "98.6万",
  time: "3小时前",
  comments: "4,286",
  image:
    "https://readdy.ai/api/search-image?query=Editorial%20dramatic%20photography%20of%20a%20dark%20empty%20film%20studio%20backstage%20with%20a%20single%20spotlight%20casting%20long%20shadows%20over%20scattered%20paper%20scripts%2C%20warm%20amber%20and%20crimson%20color%20grading%2C%20moody%20high%20contrast%20lighting%2C%20cinematic%20composition%2C%20clean%20minimal%20background%2C%20premium%20magazine%20visual%20aesthetic&width=1200&height=800&seq=hl51-hero-lead&orientation=landscape",
};

export const heroSideCards = [
  {
    id: "side-001",
    tag: "数据党",
    title: "选秀票数疑云：数据党列出三种可能解释",
    summary: "曲线为什么在同一分钟突然抬头？瓜友用公开数据做了还原。",
    heat: "76.1万",
    time: "5小时前",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20still%20life%20of%20a%20vintage%20television%20set%20glowing%20in%20a%20dim%20room%20with%20warm%20amber%20light%20and%20deep%20red%20accents%2C%20soft%20shadows%20and%20clean%20cream%20backdrop%2C%20cinematic%20mood%2C%20high%20detail%20premium%20magazine%20photography&width=800&height=600&seq=hl51-hero-side-1&orientation=landscape",
  },
  {
    id: "side-002",
    tag: "官方回应",
    title: "老牌综艺停录传闻，制作方深夜发声明",
    summary: "一句“正常调整档期”能解释所有疑问吗？评论区已经吵翻。",
    heat: "68.4万",
    time: "7小时前",
    image:
      "https://readdy.ai/api/search-image?query=Artistic%20close%20up%20of%20scattered%20newspaper%20clippings%20and%20a%20magnifying%20glass%20on%20a%20warm%20wooden%20desk%2C%20amber%20and%20crimson%20tonal%20grading%2C%20soft%20directional%20light%2C%20clean%20neutral%20background%2C%20editorial%20investigative%20mood%2C%20premium%20composition&width=800&height=600&seq=hl51-hero-side-2&orientation=landscape",
  },
];

export const quickEntries = [
  { label: "每日热榜", icon: "ri-fire-line", href: "#hot-rank" },
  { label: "最新爆料", icon: "ri-flashlight-line", href: "#latest" },
  { label: "瓜田话题", icon: "ri-plant-line", href: "#category" },
  { label: "讨论圈", icon: "ri-chat-smile-2-line", href: "#community" },
];

export const hotRankList = [
  {
    id: 1,
    tag: "独家线索",
    title: "片场临时换角风波：多方回应时间线全梳理",
    summary: "通告单、路透照、官方口径三份材料互相对照后出现的三个矛盾点。",
    heat: "98.6万",
    comments: "4,286",
    trend: "up",
  },
  {
    id: 2,
    tag: "事件追踪",
    title: "直播口播失误完整回放，瓜友逐帧找细节",
    summary: "同一句话被剪出的三个版本，究竟哪一版才是原始画面。",
    heat: "87.3万",
    comments: "3,512",
    trend: "up",
  },
  {
    id: 3,
    tag: "数据分析",
    title: "选秀票数疑云：数据党列出三种可能解释",
    summary: "把公开数据拉成曲线之后，那段异常抬升变得格外显眼。",
    heat: "76.1万",
    comments: "2,908",
    trend: "flat",
  },
  {
    id: 4,
    tag: "官方回应",
    title: "老牌综艺停录传闻，制作方深夜发布声明",
    summary: "声明只用了两句话，却让讨论圈又多出了五个新问题。",
    heat: "68.4万",
    comments: "2,140",
    trend: "down",
  },
  {
    id: 5,
    tag: "商业观察",
    title: "品牌代言名单突然调整，三方各执一词",
    summary: "官宣海报前后两版差异被眼尖瓜友逐处标了出来。",
    heat: "59.7万",
    comments: "1,876",
    trend: "up",
  },
  {
    id: 6,
    tag: "话题争议",
    title: "剧组路透照外流，造型团队被指过度借鉴",
    summary: "对比图铺满整个讨论圈，双方粉丝开启了新一轮举证。",
    heat: "51.2万",
    comments: "1,624",
    trend: "flat",
  },
  {
    id: 7,
    tag: "消费维权",
    title: "音乐节退票纠纷升级，主办方公布处理方案",
    summary: "退票规则改了三次，瓜友整理出最省事的操作路径。",
    heat: "44.8万",
    comments: "1,203",
    trend: "down",
  },
  {
    id: 8,
    tag: "行业观察",
    title: "短视频账号集体改名，背后机构浮出水面",
    summary: "同一批次改名的时间点过于整齐，引发了行业层面的猜测。",
    heat: "38.5万",
    comments: "986",
    trend: "up",
  },
];

export const hotTags = [
  "片场换角",
  "选秀票数",
  "直播口误",
  "停录传闻",
  "代言调整",
  "路透外流",
  "退票纠纷",
  "账号改名",
  "声明解读",
  "时间线复盘",
];

export const latestList = [
  {
    id: "latest-001",
    category: "时间线整理",
    title: "一条动态引发的连锁反应，48小时全记录",
    summary:
      "把每一条公开发布的时间戳按顺序排好之后，事件的走向比想象中更清晰，争议也集中在其中两个节点上。",
    time: "24分钟前",
    views: "2.1万",
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20editorial%20flat%20lay%20of%20a%20timeline%20sketch%20on%20cream%20paper%20with%20a%20brass%20pen%20and%20dried%20flowers%2C%20warm%20amber%20and%20soft%20crimson%20accents%2C%20clean%20neutral%20background%2C%20premium%20magazine%20photography%2C%20soft%20natural%20light&width=500&height=500&seq=hl51-latest-1&orientation=squarish",
  },
  {
    id: "latest-002",
    category: "关键词梳理",
    title: "这次争议到底在吵什么，四个关键词说清楚",
    summary:
      "抛开情绪之后，真正被反复提及的其实只有四个概念，理解它们基本就理解了整场讨论的来龙去脉。",
    time: "1小时前",
    views: "1.8万",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20close%20up%20of%20colorful%20paper%20tags%20with%20handwritten%20keywords%20on%20a%20warm%20wooden%20table%2C%20amber%20and%20olive%20tonal%20palette%2C%20clean%20simple%20background%2C%20editorial%20craft%20aesthetic%2C%20soft%20diffused%20lighting&width=500&height=500&seq=hl51-latest-2&orientation=squarish",
  },
  {
    id: "latest-003",
    category: "深度复盘",
    title: "从路透到官宣，中间到底发生了什么",
    summary:
      "三个阶段的公开信息被并列放在一起后，能明显看到口径的变化，这也是瓜友们讨论最热烈的地方。",
    time: "2小时前",
    views: "1.5万",
    image:
      "https://readdy.ai/api/search-image?query=Moody%20editorial%20photo%20of%20a%20stack%20of%20printed%20documents%20with%20a%20crimson%20ribbon%20marker%20on%20a%20dark%20wooden%20desk%2C%20warm%20amber%20grading%2C%20clean%20minimal%20composition%2C%20premium%20investigative%20magazine%20aesthetic&width=500&height=500&seq=hl51-latest-3&orientation=squarish",
  },
  {
    id: "latest-004",
    category: "话题投票",
    title: "网友投票结果出炉，近七成选择再观望",
    summary:
      "本轮投票一共收到两万多份有效样本，观望情绪明显，也有近两成瓜友站定了自己的判断。",
    time: "3小时前",
    views: "1.2万",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20studio%20shot%20of%20three%20wooden%20voting%20tokens%20arranged%20on%20a%20cream%20surface%2C%20warm%20amber%20and%20olive%20accents%2C%20simple%20neutral%20background%2C%20editorial%20product%20photography%2C%20soft%20even%20lighting&width=500&height=500&seq=hl51-latest-4&orientation=squarish",
  },
  {
    id: "latest-005",
    category: "声明速览",
    title: "相关方最新声明全文要点，三分钟读完",
    summary:
      "把冗长的声明拆成要点之后，真正有效的信息大约只有五条，其中两条值得重点关注。",
    time: "4小时前",
    views: "9,700",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20photograph%20of%20an%20open%20notebook%20with%20highlighted%20bullet%20points%20beside%20a%20cup%20of%20tea%2C%20amber%20and%20cream%20tones%2C%20clean%20tidy%20desk%20background%2C%20soft%20natural%20daylight%2C%20premium%20lifestyle%20photography&width=500&height=500&seq=hl51-latest-5&orientation=squarish",
  },
];

export const categoryCards = [
  {
    id: "cat-001",
    icon: "ri-fire-line",
    name: "每日热榜",
    desc: "每 10 分钟刷新一次热度排序，聚焦当下最受关注的焦点话题。",
    count: "今日 26 条",
  },
  {
    id: "cat-002",
    icon: "ri-flashlight-line",
    name: "独家线索",
    desc: "来自瓜友的一手投稿与旁证材料，由值班编辑核对后集中归档。",
    count: "今日 18 条",
  },
  {
    id: "cat-003",
    icon: "ri-plant-line",
    name: "瓜田话题",
    desc: "按题材分区整理的长期话题，方便按兴趣顺序把一个题材吃透。",
    count: "收录 342 个",
  },
  {
    id: "cat-004",
    icon: "ri-history-line",
    name: "深度复盘",
    desc: "把事件前后的公开信息重新排列，帮您快速掌握完整事件脉络。",
    count: "本周 12 篇",
  },
];

export const communityPosts = [
  {
    id: "post-001",
    nickname: "老瓜田守望者",
    role: "资深瓜友",
    time: "18分钟前",
    content:
      "把三份材料的时间戳对齐之后，第 2 条和第 5 条其实对不上。建议后来补瓜的瓜友先看复盘贴再进讨论。",
    likes: 328,
    replies: 46,
    tag: "时间线",
  },
  {
    id: "post-002",
    nickname: "数据不说谎",
    role: "数据党",
    time: "42分钟前",
    content:
      "曲线那段我用两种口径各跑了一遍，结果差异很小，所以更倾向于不是数据本身的问题。图表已放在瓜田话题里。",
    likes: 512,
    replies: 88,
    tag: "数据分析",
  },
  {
    id: "post-003",
    nickname: "只吃瓜不站队",
    role: "吃瓜群众",
    time: "1小时前",
    content:
      "目前公开信息还不足以形成结论，先把手上的线索存好。讨论圈里几位老瓜友的梳理确实省了我不少时间。",
    likes: 267,
    replies: 31,
    tag: "观点",
  },
];

export const siteStats = [
  { id: "stat-001", label: "在榜话题", value: "1,286", unit: "个", icon: "ri-fire-line" },
  { id: "stat-002", label: "今日新增线索", value: "342", unit: "条", icon: "ri-flashlight-line" },
  { id: "stat-003", label: "活跃瓜友", value: "58,900", unit: "人", icon: "ri-group-line" },
  { id: "stat-004", label: "讨论圈帖子", value: "12,470", unit: "篇", icon: "ri-chat-smile-2-line" },
];

export const footerColumns = [
  {
    title: "关于黑料51",
    links: ["站点介绍", "瓜友公约", "编辑团队", "联系方式", "加入我们"],
  },
  {
    title: "内容分区",
    links: ["每日热榜", "独家线索", "瓜田话题", "深度复盘", "话题投票"],
  },
  {
    title: "社区",
    links: ["黑料51讨论圈", "瓜友投稿", "值班编辑答疑", "站务公告"],
  },
  {
    title: "帮助与说明",
    links: ["常见问题", "内容举报指引", "免责声明", "隐私政策"],
  },
];